import "../../styles/blocks/project-page/project-summary.scss";

import React from "react";
import PropTypes from "prop-types";
import classNames from "classnames";
import {useLocation} from "@reach/router";
import {Link} from "gatsby";

const ProjectSummary = ({
                            client,
                            description,
                            linkName,
                            siteUrl,
                            manualUrl,
                            productName,
                            title,
                            year,
                            backgroundColor,
                            servicesText,
                            servicesIcon,
                            technologies = [],
                            theme = false,
                            withManual = false,
                            withContactUsButton = false,
                            className,
                            buttonTitle,
                            buttonLink
                        }) => {
    const location = useLocation();
    const manualRoute = manualUrl ?? (location.pathname[location.pathname.length - 1] === "/" ? `${location.pathname}manual/` : `${location.pathname}/manual/`);
    const sectionClasses = classNames("project-summary", className);

    const isProject = location.pathname.includes('projects');
    const isApp = location.pathname.includes('apps');


    return (
        <section
            className={sectionClasses}
            style={{
                "--section-background-color": backgroundColor
            }}
        >
            <div className="project-summary__wrapper container container--medium">
                <div className="project-summary__columns">
                    <div className="project-summary__column">
                        <h2 className="project-summary__title medium-title">
                            {title}
                        </h2>

                        <p className="project-summary__description">
                            {description}
                        </p>
                    </div>

                    <div className="project-summary__column">
                        <div className="project-summary__table">
                            <div className="project-summary__table-row">
                                <div className="project-summary__table-column project-summary__table-column--name">
                                    {theme ? 'Released' : 'Release Date'}
                                </div>

                                <div className="project-summary__table-column project-summary__table-column--value">
                                    {year}
                                </div>
                            </div>

                            {client && (
                                <div className="project-summary__table-row">
                                    <div className="project-summary__table-column project-summary__table-column--name">
                                        {theme ? 'Version' : 'Client / Partner'}
                                    </div>

                                    <div className="project-summary__table-column project-summary__table-column--value">
                                        {client}
                                    </div>
                                </div>
                            )}

                            {Boolean(technologies.length) && (
                                <div className="project-summary__table-row">
                                    <div className="project-summary__table-column project-summary__table-column--name">
                                        Services
                                    </div>

                                    <div className="project-summary__table-column project-summary__table-column--value">
                                        {technologies.map((({name, id, acfTechnology}) => {
                                            const icon = acfTechnology?.icon;

                                            return (
                                                <div key={id} className="project-summary__service">
                                                    {icon && (
                                                        <div className="icon-wrapper" aria-hidden="true"
                                                             dangerouslySetInnerHTML={{__html: icon}}/>
                                                    )}

                                                    {name}
                                                </div>
                                            );
                                        }))}
                                    </div>
                                </div>
                            )}


                            {
                                theme ?
                                    <div className="project-summary__table-row">
                                        <div
                                            className="project-summary__table-column project-summary__table-column--name">
                                            {theme ? 'Support' : 'Site'}
                                        </div>

                                        <div
                                            className="project-summary__table-column project-summary__table-column--value">
                                            {theme ?
                                                <a
                                                    className="project-summary__site-link"
                                                    href={siteUrl.url}
                                                    target="_blank"
                                                    rel="noreferrer"
                                                    aria-label={`Link will be opened in a new tab - ${linkName}`}
                                                >
                                                    {linkName}
                                                </a> :
                                                <a
                                                    className="project-summary__site-link"
                                                    href={siteUrl.url}
                                                    target="_blank"
                                                    rel="noreferrer"
                                                    aria-label={`Link will be opened in a new tab - ${siteUrl.url}`}
                                                >
                                                    {siteUrl.url}
                                                </a>}

                                        </div>
                                    </div>
                                    : null

                            }

                            {
                                servicesText && <div className="project-summary__table-row">
                                    <div className="project-summary__table-column project-summary__table-column--name">
                                        Services
                                    </div>

                                    <div
                                        className="project-summary__table-column project-summary__table-column--flex project-summary__table-column--value">
                                        <div className="icon-wrapper project-summary__table-column-icon"
                                             dangerouslySetInnerHTML={{__html: servicesIcon}}/>

                                        <p className="project-summary__table-column-text">
                                            {servicesText}
                                        </p>
                                    </div>
                                </div>
                            }

                            {
                                withManual && <div className="project-summary__table-row">
                                    <div
                                        className="project-summary__table-column project-summary__table-column--name project-summary__table-column--red">
                                        Manual
                                    </div>

                                    <div className="project-summary__table-column project-summary__table-column--value">
                                        <Link
                                            className="project-summary__site-link"
                                            to={manualRoute}
                                            {...(manualUrl && { target: "_blank", rel: "noopener noreferrer" })}
                                        >
                                            Read more
                                            <span className="visually-hidden"> about the {productName || title} manual</span>
                                        </Link>
                                    </div>
                                </div>
                            }

                            {
                                !isProject && (
                                    isApp ? <div className="project-summary__table-row">
                                        <div className="project-summary__table-column project-summary__table-column--name">
                                            Email
                                        </div>

                                        <div className="project-summary__table-column project-summary__table-column--value">
                                            <a
                                                className="project-summary__site-link"
                                                href="mailto:support@utdapp.tech"
                                                aria-label="Contact us on our email"
                                            >
                                                support@utdapp.tech
                                            </a>
                                        </div>
                                    </div> : <div className="project-summary__table-row">
                                        <div className="project-summary__table-column project-summary__table-column--name">
                                            Email
                                        </div>

                                        <div className="project-summary__table-column project-summary__table-column--value">
                                            <a
                                                className="project-summary__site-link"
                                                href="mailto:support@utdweb.team"
                                                aria-label="Contact us on our email"
                                            >
                                                support@utdweb.team
                                            </a>
                                        </div>
                                    </div>
                                )
                            }

                            {
                                withContactUsButton && <div className="project-summary__table-row">
                                    <Link
                                        to={'/contact-us/'}
                                        className="button"
                                    >
                                        Let's talk
                                    </Link>
                                </div>
                            }

                            {
                                buttonLink && buttonTitle && <div className="project-summary__table-row">
                                    <a
                                        className="button"
                                        href={buttonLink}
                                        target="_blank"
                                        rel="noreferrer"
                                        aria-label={`${buttonTitle}. Link will be opened in a new tab.`}
                                    >
                                        {buttonTitle}
                                    </a>
                                </div>
                            }
                        </div>
                    </div>
                </div>
            </div>
        </section>
    );
};

ProjectSummary.propTypes = {
    client: PropTypes.string,
    description: PropTypes.string.isRequired,
    title: PropTypes.string.isRequired,
    productName: PropTypes.string,
    year: PropTypes.string.isRequired,
    technologies: PropTypes.array
};

export default ProjectSummary;
